/* USC peel-to-reveal sign-up popup. Markup lives in snippets/usc-peel-popup.liquid. */
(() => {
  const root = document.getElementById("uscpp");
  if (!root) return;

  const COMPANY_ID = root.dataset.companyId;
  const EMAIL_LIST = root.dataset.emailList;
  const SMS_LIST = root.dataset.smsList;
  const STORE_KEY = "uscpp_state";
  const SHOW_AFTER_MS = 8000;
  const DISMISS_DAYS = 7;
  // Colors always in Red, Black, Blue order.
  const TAPES = [
    { key: "red", name: "red", rot: -6 },
    { key: "black", name: "black", rot: 4 },
    { key: "blue", name: "blue", rot: -3 },
  ];
  const PRIZE = { bubble: "10% off!" };

  const $ = (id) => document.getElementById(id);
  const q = (sel) => root.querySelector(sel);
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  let isOpen = false, peeled = false, email = "", lastFocus = null;

  // ---------- when to show
  function readState() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeState(s) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify({ s, t: Date.now() })); } catch (e) {}
  }
  const params = new URLSearchParams(location.search);
  const forced = params.get("peel_popup") === "1";
  // People arriving from our own emails/texts are already subscribed.
  if (/^(email|sms)$/i.test(params.get("utm_medium") || "") || params.has("_kx")) writeState("subscribed");
  const state = readState();
  const recentlyDismissed = state.s === "dismissed" && Date.now() - state.t < DISMISS_DAYS * 864e5;
  if (!forced && (state.s === "subscribed" || recentlyDismissed)) return;

  // ---------- funnel tracking -> Performance Portal's Popup page.
  // Test opens (?peel_popup=1) aren't counted.
  const TRACK_URL = "https://performance.uglysleepclub.com/api/popup-event";
  function visitorId() {
    try {
      let id = localStorage.getItem("uscpp_vid");
      if (!id) {
        id = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        localStorage.setItem("uscpp_vid", id);
      }
      return id;
    } catch (e) {
      return "nostore" + Math.random().toString(36).slice(2, 10);
    }
  }
  function track(event) {
    if (forced) return;
    const body = JSON.stringify({
      event,
      vid: visitorId(),
      device: window.matchMedia("(max-width: 768px)").matches ? "mobile" : "desktop",
      path: location.pathname,
    });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(TRACK_URL, new Blob([body], { type: "text/plain" }))) return;
    } catch (e) {}
    fetch(TRACK_URL, { method: "POST", body, mode: "no-cors", keepalive: true, headers: { "Content-Type": "text/plain" } }).catch(() => {});
  }

  if (forced) {
    setTimeout(open, 300);
  } else {
    setTimeout(open, SHOW_AFTER_MS);
    // desktop exit intent
    if (window.matchMedia("(pointer: fine)").matches) {
      setTimeout(() => {
        document.addEventListener("mouseout", function onOut(e) {
          if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener("mouseout", onOut); open(); }
        });
      }, 2000);
    }
  }

  // ---------- open / close
  function loadFont() {
    if (document.getElementById("uscpp-font")) return;
    const l = document.createElement("link");
    l.id = "uscpp-font"; l.rel = "stylesheet";
    l.href = "https://fonts.googleapis.com/css2?family=Shrikhand&display=swap";
    document.head.appendChild(l);
  }
  function open() {
    if (isOpen || readState().s === "subscribed" && !forced) return;
    isOpen = true;
    loadFont();
    buildTapes();
    show("peel");
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.style.overflow = "hidden";
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add("is-open")));
    q(".uscpp-close").focus({ preventScroll: true });
    track("shown");
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    if (readState().s !== "subscribed") { writeState("dismissed"); track("closed"); }
    root.classList.remove("is-open");
    document.documentElement.style.overflow = "";
    setTimeout(() => { root.hidden = true; }, reduce ? 0 : 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  root.querySelectorAll("[data-uscpp-close]").forEach((b) => b.addEventListener("click", close));
  root.addEventListener("click", (e) => { if (e.target === root) close(); });
  document.addEventListener("keydown", (e) => { if (isOpen && e.key === "Escape") close(); });

  function setHeader(eyebrow, title, sub) {
    $("uscpp-eyebrow").textContent = eyebrow;
    $("uscpp-title").textContent = title;
    $("uscpp-sub").textContent = sub;
  }
  function show(step) {
    root.querySelectorAll("[data-uscpp-step]").forEach((el) => { el.hidden = el.dataset.uscppStep !== step; });
  }

  // ---------- step 1: peel
  function buildTapes() {
    peeled = false;
    setHeader("Ugly Sleep Club", "Peel a tape. Keep the prize.", "Every tape is hiding a welcome offer.\nPick one and peel it off.");
    $("uscpp-hint").textContent = "Grab an end and drag to peel. Or just tap one.";
    const wrap = $("uscpp-mouths");
    wrap.innerHTML = "";
    for (const t of TAPES) {
      const node = $("uscpp-mouth-tpl").content.firstElementChild.cloneNode(true);
      const tape = node.querySelector(".uscpp-tape");
      tape.classList.add("uscpp-tape--" + t.key);
      tape.style.setProperty("--r", t.rot + "deg");
      tape.setAttribute("aria-label", `Peel the ${t.name} mouth tape`);
      wrap.appendChild(node);
      wireTape(tape, node, t);
    }
  }

  function wireTape(tape, mouth, t) {
    const face = tape.querySelector(".uscpp-face");
    const flap = tape.querySelector(".uscpp-flap");
    const angle = (t.rot * Math.PI) / 180;
    let dragging = false, touched = false, x0 = 0, y0 = 0, W = 0, moved = false;

    // Set the tape image and the flap's mask ONCE as plain inline styles.
    // Re-resolving them every frame (through CSS variables) made Safari
    // briefly paint nothing, so the tapes flickered and showed the lips.
    const img = getComputedStyle(root).getPropertyValue("--uscpp-img-" + t.key).trim();
    face.style.backgroundImage = img;
    flap.style.webkitMaskImage = img;
    flap.style.maskImage = img;
    // The mask is sized to the full tape width; only touched when that width
    // actually changes, never re-set on every frame.
    let maskW = 0;
    function sizeMask() {
      const w = tape.offsetWidth;
      if (!w || w === maskW) return;
      maskW = w;
      flap.style.webkitMaskSize = w + "px 100%";
      flap.style.maskSize = w + "px 100%";
    }

    function render(fold, lift, tilt) {
      sizeMask();
      if (fold < 0.5) {
        face.style.clipPath = "none";
        face.style.webkitClipPath = "none";
        flap.style.visibility = "hidden";
        flap.style.width = "0px";
        return;
      }
      const clip = `inset(0 0 0 ${fold}px)`;
      face.style.clipPath = clip;
      face.style.webkitClipPath = clip;
      flap.style.visibility = "visible";
      flap.style.left = fold + "px";
      flap.style.width = fold + "px";
      flap.style.transform = `translateY(${-lift}px) rotate(${tilt}deg) translateX(${fold}px) scaleX(-1)`;
    }

    // idle hint: the left end lifts a little now and then until someone touches a tape
    if (!reduce) {
      const order = TAPES.indexOf(t);
      const nudge = () => {
        if (peeled || touched || !isOpen || !tape.isConnected) return;
        const w = tape.offsetWidth, start = performance.now();
        const step = (now) => {
          if (dragging || peeled || touched) return;
          const p = Math.min(1, (now - start) / 900);
          const k = Math.sin(p * Math.PI);
          render(k * w * 0.09, k * 2, -2 * k);
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
        setTimeout(nudge, 3200);
      };
      setTimeout(nudge, 700 + order * 450);
    }

    tape.addEventListener("pointerdown", (e) => {
      if (peeled) return;
      dragging = true; touched = true; moved = false;
      tape.classList.remove("is-snap");
      tape.setPointerCapture(e.pointerId);
      x0 = e.clientX; y0 = e.clientY; W = tape.offsetWidth;
      render(0, 0, 0);
    });
    tape.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      const dx = e.clientX - x0, dy = e.clientY - y0;
      // project the drag onto the tape's own axis
      const along = dx * Math.cos(angle) + dy * Math.sin(angle);
      const across = -dx * Math.sin(angle) + dy * Math.cos(angle);
      if (Math.abs(along) > 4) moved = true;
      const f = Math.max(0, Math.min(W, along * 0.65));
      render(f, Math.min(10, Math.max(0, -across) * 0.25 + f * 0.04), Math.max(-14, Math.min(14, across * 0.2)));
      if (f > W * 0.55) finish();
    });
    const release = () => {
      if (!dragging) return;
      dragging = false;
      if (peeled) return;
      if (!moved) { autoPeel(); return; }
      tape.classList.add("is-snap");
      render(0, 0, 0);
    };
    tape.addEventListener("pointerup", release);
    tape.addEventListener("pointercancel", release);
    tape.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); autoPeel(); }
    });

    // tap or keyboard: animate the peel for them
    function autoPeel() {
      if (peeled) return;
      touched = true;
      W = tape.offsetWidth;
      if (reduce) { finish(); return; }
      const start = performance.now(), dur = 520;
      const step = (now) => {
        const p = Math.min(1, (now - start) / dur);
        const e = 1 - Math.pow(1 - p, 3);
        const fold = e * W * 0.56;
        render(fold, fold * 0.06, -4 * e);
        if (p < 1 && !peeled) requestAnimationFrame(step); else finish();
      };
      requestAnimationFrame(step);
    }

    function finish() {
      if (peeled) return;
      peeled = true;
      dragging = false;
      tape.classList.add("is-gone");
      mouth.querySelector(".uscpp-bubble").textContent = PRIZE.bubble;
      setTimeout(() => mouth.classList.add("is-open"), 120);
      root.querySelectorAll(".uscpp-mouth").forEach((m) => { if (m !== mouth) m.classList.add("is-dim"); });
      root.querySelectorAll(".uscpp-tape").forEach((tp) => { if (tp !== tape) tp.disabled = true; });
      $("uscpp-hint").textContent = "Nice peel.";
      track("peeled");
      if (!reduce) scraps(mouth, t.key);
      setTimeout(showEmail, reduce ? 400 : 1500);
    }
  }

  function scraps(mouth, key) {
    const card = q(".uscpp-card");
    const cr = card.getBoundingClientRect(), mr = mouth.getBoundingClientRect();
    const cx = mr.left - cr.left + mr.width / 2, cy = mr.top - cr.top + mr.height / 2;
    const tapeColor = { red: "#d9473d", black: "#22232a", blue: "#79c0e6" }[key];
    const colors = [tapeColor, "#e46a80", "#c2e6f9", "#17243a"];
    for (let i = 0; i < 18; i++) {
      const s = document.createElement("span");
      s.className = "uscpp-scrap";
      s.style.background = colors[i % colors.length];
      s.style.left = cx + "px"; s.style.top = cy + "px";
      card.appendChild(s);
      const a = Math.random() * Math.PI * 2, d = 60 + Math.random() * 90;
      const anim = s.animate([
        { transform: "translate(0,0) rotate(0deg)", opacity: 1 },
        { transform: `translate(${Math.cos(a) * d}px, ${Math.sin(a) * d + 40}px) rotate(${Math.random() * 540}deg)`, opacity: 0 },
      ], { duration: 900 + Math.random() * 400, easing: "cubic-bezier(.2,.7,.4,1)" });
      anim.onfinish = () => s.remove();
    }
  }

  // ---------- Klaviyo
  async function subscribe(listId, profile) {
    const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(COMPANY_ID)}`, {
      method: "POST",
      headers: { "Content-Type": "application/vnd.api+json", Accept: "application/vnd.api+json", revision: "2024-10-15" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Peel Popup",
            profile: { data: { type: "profile", attributes: profile } },
          },
          relationships: { list: { data: { type: "list", id: listId } } },
        },
      }),
    });
    if (!res.ok) throw new Error("Klaviyo subscribe failed: " + res.status);
  }

  async function submitWith(form, errorEl, work) {
    const btn = form.querySelector('button[type="submit"]');
    btn.disabled = true;
    try { await work(); }
    catch (err) {
      console.error(err);
      errorEl.textContent = "That didn't go through. Check your connection and try again.";
      errorEl.hidden = false;
    }
    finally { btn.disabled = false; }
  }

  // ---------- step 2: email
  function showEmail() {
    setHeader("Nice peel", "You won 10% off!", "Pop in your email and we'll unlock your code.");
    show("email");
    $("uscpp-email").focus({ preventScroll: true });
  }
  $("uscpp-email-form").addEventListener("submit", (e) => {
    e.preventDefault();
    const value = $("uscpp-email").value.trim();
    const err = $("uscpp-email-error");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
      err.textContent = "Enter a full email address, like you@email.com.";
      err.hidden = false;
      $("uscpp-email").focus();
      return;
    }
    err.hidden = true;
    submitWith(e.target, err, async () => {
      // The client endpoint records consent from the email itself; it rejects a "subscriptions" field.
      await subscribe(EMAIL_LIST, { email: value });
      email = value;
      writeState("subscribed");
      track("email");
      showSms();
    });
  });

  // ---------- step 3: text upgrade
  function showSms() {
    setHeader("Want more?", "Upgrade to 15% off.", "Add your number and we'll text you a bigger code, plus first dibs on drops.");
    show("sms");
    $("uscpp-phone").focus({ preventScroll: true });
  }
  $("uscpp-sms-form").addEventListener("submit", (e) => {
    e.preventDefault();
    const digits = $("uscpp-phone").value.replace(/\D/g, "").replace(/^1(?=\d{10}$)/, "");
    const err = $("uscpp-sms-error");
    if (digits.length !== 10) {
      err.textContent = "Enter a 10-digit US phone number.";
      err.hidden = false;
      $("uscpp-phone").focus();
      return;
    }
    err.hidden = true;
    submitWith(e.target, err, async () => {
      await subscribe(SMS_LIST, { email, phone_number: "+1" + digits });
      track("sms");
      showDone(true);
    });
  });
  $("uscpp-sms-skip").addEventListener("click", () => showDone(false));

  // ---------- step 4: done. The welcome flows send the codes.
  function showDone(upgraded) {
    if (upgraded) {
      setHeader("Welcome to the club", "Check your texts.", "Your 15% code is on its way to your phone.");
      $("uscpp-done-big").textContent = "15% OFF";
      $("uscpp-done-what").textContent = "is on its way by text";
      $("uscpp-done-fine").hidden = true;
    } else {
      setHeader("Welcome to the club", "Check your inbox.", `Your code is on its way to ${email}.`);
      $("uscpp-done-big").textContent = "10% OFF";
      $("uscpp-done-what").textContent = "is on its way to your inbox";
      $("uscpp-done-fine").hidden = false;
    }
    show("done");
  }
})();
